const Light = {
  fontFamily: 'Light',
};

const Regular = {
  fontFamily: 'Regular',
};

const SemiBold = {
  fontFamily: 'SemiBold',
};

const Bold = {
  fontFamily: 'Bold',
};

export default {
  Light,
  Regular,
  SemiBold,
  Bold,
};
